import React, {useCallback, useRef, useState} from 'react'
import {
  Layout,
  Page,
  Card,
  TextField,
  Checkbox,
  FormLayout,
  SkeletonBodyText,
  List,
  Link,
  FooterHelp, Button
} from '@shopify/polaris'
import { useDispatch, useSelector } from 'react-redux'

import { formatHTML } from '../../libs/utils'
import useShouldSendRequest from '../../hooks/useShouldSendRequest'
import {actionSetToastError, actionSetToastMessage, actionToggleToastActive} from "../../store/actions";

const GalleryCodeComponent = (props) => {
  const dispatch = useDispatch()
  const editingId = props.match ? props.match.params.id : false
  const activeItem = useSelector(state => state.activeItem)
  const app = useSelector(state => state.app)
  const codeArea = useRef(null)
  const shouldLoading = useShouldSendRequest(
    `/api/v2/admin/gallery/${editingId}`,
    editingId && !Object.keys(activeItem).length
  )

  const copyToClipboard = useCallback((e) => {
    if (codeArea) {
      const textarea = codeArea.current.querySelector('textarea')
      if (textarea) {
        textarea.select()
        document.execCommand('copy')
        textarea.focus()
        dispatch(actionSetToastMessage('Code copied.'))
        dispatch(actionSetToastError(false))
        dispatch(actionToggleToastActive(true))
      }
    }
  }, [])

  const mapperCode = activeItem && Object.keys(activeItem).length ? `
    <div>
      <div
        id="image-mapper-gallery-${editingId}"
        class="image-mapper image-mapper--gallery"
        data-mapper-module="mapper"
        data-mapper='{
          "url": "${app.appUrl}/api/v2/galleries/${editingId}"
        }'
        ${activeItem.gallery_type === 'masonry' ? `data-masonry='{}'` : ''}>
      </div>
    </div>` : <div/>
  return (
    <Page
      fullWidth
      breadcrumbs={[{
        content: 'Gallery',
        url: '/galleries'
      }]}
      title='Gallery code'
    >
      {shouldLoading && <SkeletonBodyText />}
      {!shouldLoading && <Layout>
        <Layout.Section oneHalf>
          <Card title="Code" sectioned>
            <FormLayout>
              {codeArea && <Button plain onClick={copyToClipboard}>Click here to copy code</Button>}
              <div ref={codeArea}>
                <TextField
                  readOnly
                  value={formatHTML(mapperCode)}
                  multiline={4}
                />
              </div>
            </FormLayout>
          </Card>
        </Layout.Section>
        <Layout.Section oneHalf>
          <Card title="FAQs" sectioned>
            <List type="bullet">
              <List.Item>
                <Link url="/docs#/faqs/how-to-add-a-mappergallery-to-a-homepage" external>How to add a mapper/gallery to your homepage?</Link>
              </List.Item>
              <List.Item>
                <Link url="/docs#/faqs/how-to-add-a-mappergallery-to-a-page" external>How to add a mapper/gallery to a page?</Link>
              </List.Item>
              <List.Item>
                <Link url="/docs#/faqs/how-to-add-a-mappergallery-to-a-blog-post" external>How to add a mapper/gallery to a blog post?</Link>
              </List.Item>
              <List.Item>
                <Link url="/docs#/faqs/how-to-add-a-mappergallery-to-a-product" external>How to add a mapper/gallery to a product page?</Link>
              </List.Item>
              <List.Item>
                <Link url="/docs#/faqs/how-to-add-a-mappergallery-to-a-collection" external>How to add a mapper/gallery to a collection page?</Link>
              </List.Item>
            </List>
          </Card>
        </Layout.Section>
      </Layout>}
      <FooterHelp>
        Learn more about<Link url="/docs#/get-and-install-code" external> installing a gallery</Link>
      </FooterHelp>
    </Page>
  )
}

export default GalleryCodeComponent
